import { useState, useEffect } from "react";
import { Sun, Moon } from "lucide-react";
import { motion } from "framer-motion";

const ThemeToggle = () => {
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("theme");
    if (saved === "light") {
      setIsLight(true);
      document.documentElement.classList.add("light");
    }
  }, []);

  const toggleTheme = () => {
    if (isLight) {
      document.documentElement.classList.remove("light");
      localStorage.setItem("theme", "dark");
      setIsLight(false);
    } else {
      document.documentElement.classList.add("light");
      localStorage.setItem("theme", "light");
      setIsLight(true);
    }
  };

  return (
    <button
      onClick={toggleTheme}
      className="relative flex items-center w-[60px] h-8 p-1 rounded-full bg-foreground/10 transition-colors duration-300 border border-border"
      aria-label="Alternar tema"
    >
      {/* Knob deslizante */}
      <motion.div
        initial={false}
        animate={{ x: isLight ? 0 : 28 }}
        transition={{ type: "spring", stiffness: 400, damping: 25 }}
        className={`absolute w-6 h-6 rounded-full shadow-sm ${
          isLight ? "bg-background" : "bg-primary"
        }`}
      />
      
      <div className="relative z-10 flex w-full justify-between items-center px-1">
        <Sun className={`w-4 h-4 transition-colors duration-300 ${isLight ? "text-orange-500" : "text-foreground/40"}`} />
        <Moon className={`w-4 h-4 transition-colors duration-300 ${!isLight ? "text-primary-foreground" : "text-foreground/40"}`} />
      </div>
    </button>
  );
};

export default ThemeToggle;
